// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IAnyModelType, Instance, SnapshotIn, types } from 'mobx-state-tree'
import { baseModel } from 'store/utils/base-model'
import { reference } from 'store/utils/reference'
import { User } from '../users'
import { Position } from '../positions'
import { createStore } from 'store/utils/create-store'

export const UserSalary = baseModel('user_salaries').props({
  user: reference(types.late((): IAnyModelType => User)),
  position: reference(types.late((): IAnyModelType => Position)),
  amountCents: types.number,
  currency: types.string,
  payFrequency: types.string,
  createdAt: types.string,
})

export interface UserSalary extends Instance<typeof UserSalary> {}

export const UserSalaryStore = createStore<typeof UserSalary>(
  'user_salaries',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  UserSalary as any
)

export default UserSalary
